<template>
    <b-modal size="lg" v-model="show" id="addToTabModal" centered :title="$t('pos_guests_modal_title')">
      <b-form class="add-to-tab-form">
        <b-form-select v-model="selectedTab" :options="selectableTabs" :select-size="10"/>
      </b-form>
      <div slot="modal-footer" class="w-100">
        <b-btn class="float-right" variant="success" @click="addToTab(tabs.find(tab => tab.id ===selectedTab))">
          Add To Open Tab
        </b-btn>
      </div>
    </b-modal>
</template>

<script>
  export default {
    name: "AddToTabModal",
    props: {
      addToTab: {
        type: Function,
        required: true,
        default: () => {}
      },
      tabs: {
        type: Array,
        required: true,
        default: () => []
      }
    },
    data() {
      return {
        show: false,
        selectedTab: null
      }
    },
    methods: {
      hide() {
        this.show = false;
      },
    },
    computed: {
      selectableTabs() {
        return this.tabs.map(tab => {
          return {
            value: tab.id,
            text: `${tab.name}`
          }
        }).filter(tab => tab.value !== 0)
      }
    }
  };
</script>

<style lang="scss">
  #createTabModal.modal-dialog-centered {
      min-width: 800px;

      .modal-header {
        height: initial;
        width: initial;
      }
      .modal-open {
        margin: auto;
      }
  }
</style>
